import { createStore } from 'vuex';
import authentication from '@/modules/authentication/store';
import language from '@/modules/language/store';

const store = createStore({
    modules: {
        authentication: authentication,
        language: language,
    },
});

export default store;
